import { render, staticRenderFns } from "./GetAllOrders.vue?vue&type=template&id=403d735d"
import script from "./GetAllOrders.vue?vue&type=script&lang=js"
export * from "./GetAllOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports